module.exports = __webpack_public_path__ + "media/images/photos-btn-f2a5241b6e11be30ac84301f6145edde4bbced5027eaa9d596cf30b58021a0d9.png";